import React, { useEffect, useState } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import { Formik } from "formik";
import DatePickercomp from "../../components/DatePicker";
import MyInput from "../../components/MyInput";
import { BsUpload } from "react-icons/bs";
import { Helmet } from "react-helmet";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import {
  getAllBankListForDropdown,
  getSingleAccountDetailsById,
  postAccountDetails,
  updateAccountDetails,
} from "../../services/contractorApi";
import { addCreditor, updateCreditor } from "../../services/contractorApi";
import { ViewTransaction } from "../MasterDataManagement/AccountManagement/ViewTransaction";
import { getAdminAllHREmployees } from "../../services/authapi";
// import { bankToBankTransferSchema } from "../../utils/formSchema";

import CardComponent from "../../components/CardComponent";
import { getAllAccountDetails } from "../../services/contractorApi";
import { useSelector } from "react-redux";
import ConfirmAlert from "../../components/ConfirmAlert";
import { getAllPaymentModes } from "../../services/contractorApi";
import Select from "react-select";
import { addBankToBankTransfer } from "../../services/contractorApi";
import { addBanktobanktransferSchema } from "../../utils/formSchema";
import { getallbanktobankTransaction } from "../../services/authapi";
import { updateBankToBankTransfer } from "../../services/contractorApi";

import { onlyDecimalKey, handleDecimalPaste } from "../../utils/helper";
const BankTransaction = () => {
  const { id } = useParams();

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type") || null;
  const isuser = searchParams.get("isuser") || null;
  const [edit, setEdit] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [allBankData, setAllBankData] = useState([]);
  const [creationDate, setCreationDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const { t } = useTranslation();
  const user_id = useSelector((state) => state.auth.user.id);
  const user_type = useSelector((state) => state.auth.user.user_type);
  const [fromHolderName, setFromHolderName] = useState("");
  const [toHolderName, setToHolderName] = useState("");

  const [rows, setRows] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const [userAccount, setUserAccount] = useState([]);
  const [firmBankAccount, setFirmBankAccount] = useState([]);
  const [creditorsdata, setCreditorData] = useState([]);
  const [paymentMode, setPaymentMode] = useState([]);
  const [filteredFirmBankAccount, setFilteredFirmBankAccount] = useState([]);
  const [filteredUserAccount, setFilteredUserAccount] = useState([]);
  const [amountError, setAmountError] = useState("");
  // const [transactionTypeError, setTransactionType] = useState("");

  const fetchAllBank = async () => {
    const res = await getAllBankListForDropdown();
    if (res.status) {
      const rData = res.data.map((itm) => {
        return {
          value: itm.bank_name,
          label: itm.bank_name,
          logo: itm.logo,
        };
      });
      setAllBankData(rData);
    } else {
      setAllBankData([]);
    }
  };

  let statusOptions = [
    { label: "Active", value: 1 },
    { label: "Inactive", value: 0 },
  ];

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    console.log("values", values);
    if (!values) return [];

    const formData = new FormData();

    Object.entries(values).forEach(([key, value]) => {
      formData.append(key, value);
    });

    // formData.append("transaction_for", values.transaction_for);

    // 👇 Check exactly what’s going to backend
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }

    if (edit?.account_id) {
      formData.append("account_transfer_id", id);
      // formData.append("creation_date", edit?.created_at);
    }
    if (edit?.id) {
      formData.append("user_transfer_id", edit?.id);
    }

    // if (edit?.txn_category === "BU") {
    //   formData.append("transaction_type", "UU");
    // }
    formData.append("user_id", user_id);
    const res =
      edit?.account_id || edit?.id
        ? await updateBankToBankTransfer(formData, edit?.account_id)
        : await addBankToBankTransfer(formData);

    if (res.status === true) {
      toast.success(res.message);
      navigate(-1);

      resetForm();
    } else {
      toast.error(res.message);
      setShowAlert(false);
    }
    setSubmitting(false);
  };

  const handleDateChange = (date) => {
    console.log("date", date);
  };

  const fetchAllHrEmployeesData = async () => {
    const res = await getAdminAllHREmployees({
      search,
      pageSize,
      pageNo,
      forAccount: true,
      isDropdown: true,
    });
    if (res.status) {
      const data = res.data.filter(
        (item) =>
          item.account_number !== null &&
          item.bank_name !== null &&
          item.bank_name !== "" &&
          item.is_creditor == 0
      );
      setUserAccount(
        data.map((item) => {
          return {
            value: item.id,
            label: `${item.name} - ${item.bank_name} - ₹${item.closing_balance}`,
            account_number: item.account_number,
            closing_balance: item.closing_balance,
            fund_limit: item.fund_limit ?? 0,
          };
        })
      );
      setTotalData(res?.pageDetails?.total);
    } else {
      setUserAccount([]);
      setTotalData(0);
    }
    setIsLoading(false);
  };

  const fetchAllHrCrediotrsData = async () => {
    const res = await getAdminAllHREmployees({
      search,
      pageSize,
      pageNo,
      forAccount: true,
      isCreditor: true,
    });
    if (res.status) {
      // const data = res.data.filter((item) => item.account_number);
      setCreditorData(
        res.data.map((item) => {
          return {
            value: item.id,
            label: `${item.name} - ${item.bank_name} - ₹${item.closing_balance}`,
            account_number: item.account_number,
            closing_balance: item.closing_balance,
          };
        })
      );

      setTotalData(res?.pageDetails?.total);
    } else {
      setRows([]);
      setTotalData(0);
    }
    setIsLoading(false);
  };

  const fetchallbankTransactions = async () => {
    const params = {
      [type === "UU" ? "user_transfer_id" : "accounts_transfer_id"]: id,
    };
    const res = await getallbanktobankTransaction(params);
    if (res.status) {
      // const data = res.data.filter((item) => item.account_number);
      setEdit(res.data[0]);
      setFromHolderName(
        res.data[0].from_bank_account_number ||
          res.data[0].from_user_account_number
      );
      setToHolderName(
        res.data[0].to_user_account_number || res.data[0].to_bank_account_number
      );

      setTotalData(res?.pageDetails?.total);
    } else {
      setRows([]);
      setTotalData(0);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (id !== "new") {
      fetchPaymentModes();
      fetchAllHrEmployeesData();
      fetchallbankTransactions();

      fetchAllBankData();
      fetchAllHrCrediotrsData();
    }
  }, [id, isuser]);

  const transactionTypes = [
    { value: "BB", label: "Company Account → Company Account" },
    { value: "BU", label: "Company Account → User Account" },
    { value: "BC", label: "Company Account → Creditor Account" },
    { value: "UB", label: "User Account → Company Account" },
    { value: "CB", label: "Creditor Account → Company Account" },
    { value: "UU", label: "User → User" },
  ];

  const transactionFor = [
    { value: "F", label: " Fund" },
    { value: "S", label: " Stock" },
  ];

  // Dummy account options

  const fetchAllBankData = async () => {
    const res = await getAllAccountDetails(
      search,
      pageSize,
      pageNo,
      user_id,
      user_type
    );
    setIsLoading(true);
    if (res.status) {
      setFirmBankAccount(
        res.data
          .filter((item) => item.bank_name !== "Cash Account")
          .map((item) => {
            return {
              value: item.id,
              label: `${item.account_holder_name} - ${item.bank_name} - ₹${item.closing_balance}`,
              account_number: item.account_number,
              closing_balance: item.closing_balance,
              fund_limit: item.fund_limit ?? 0,
            };
          })
      );
      setTotalData(res?.pageDetails?.total);
    } else {
      setRows([]);
      setTotalData(0);
    }
    setIsLoading(false);
  };
  const fetchPaymentModes = async (transactionType) => {
    const res = await getAllPaymentModes();
    if (res?.status) {
      let rData = res?.data
        .filter((item) => item.method !== "CASH")
        .map((d) => ({
          label: d.method,
          value: d.id,
        }));

      // yaha filtering apply
      // if (["BU", "UB", "BC", "CB", "UU"].includes(transactionType)) {
      //   // remove Cash
      // rData = rData.filter((mode) => mode.label.toLowerCase() !== "cash");

      setPaymentMode(rData);
    } else {
      setPaymentMode([]);
    }
  };

  // const getAccountDetails = (transactionType, toAccountId) => {
  //   if (!transactionType || !toAccountId) return null;
  //   if (["BU", "UU"].includes(transactionType)) {
  //     return userAccount?.find((acc) => acc.value === toAccountId);
  //   }
  //   return null;
  // };

  // const getFromAccountDetails = (transactionType, fromAccountId) => {
  //   if (!transactionType || !fromAccountId) return null;

  //   if (["UB","BU", "UU"].includes(transactionType)) {
  //     return userAccount?.find((acc) => acc.value === fromAccountId);
  //     // console.log("yo", a);

  //   } else if (["BC", "BB"].includes(transactionType)) {
  //     return firmBankAccount?.find((acc) => acc.value === fromAccountId);// creditorsdata
  //     // console.log("hello", c);

  //   }
  //   else if (["CB"].includes(transactionType)) {
  //     return creditorsdata?.find((acc) => acc.value === fromAccountId);
  //     // console.log("////",b);
  //   }
  //   return null;
  // };

  const getAccountDetails = (transactionType, toAccountId) => {
    if (!transactionType || !toAccountId) return null;
    const id = Number(toAccountId);
    let account = null;

    if (["BU", "UU"].includes(transactionType)) {
      account = userAccount?.find((acc) => Number(acc.value) === id);
    } else if (["BC"].includes(transactionType)) {
      account = creditorsdata?.find((acc) => Number(acc.value) === id);
    } else if (["UB", "CB", "BB"].includes(transactionType)) {
      account = firmBankAccount?.find((acc) => Number(acc.value) === id);
    }

    if (account && !account.closing_balance && account.label) {
      const match = account.label.match(/₹(\d+)/);
      account.closing_balance = match ? Number(match[1]) : 0;
    }

    return account;
  };

  const getFromAccountDetails = (transactionType, fromAccountId) => {
    if (!transactionType || !fromAccountId) return null;

    const id = Number(fromAccountId);
    let account = null;

    // 🏦 For User-related transactions, get from userAccount
    if (["UB", "UU"].includes(transactionType)) {
      account = userAccount?.find((acc) => Number(acc.value) === id);
    }
    // 🏢 For Company/Firm bank transactions, get from firmBankAccount
    else if (["BB", "BU", "BC"].includes(transactionType)) {
      account = firmBankAccount?.find((acc) => Number(acc.value) === id);
    }
    // 💸 For Creditor-related transactions
    else if (["CB"].includes(transactionType)) {
      account = creditorsdata?.find((acc) => Number(acc.value) === id);
    }

    // 🧩 Extract closing_balance from label if missing
    if (account && !account.closing_balance && account.label) {
      const match = account.label.match(/₹(\d+)/);
      account.closing_balance = match ? Number(match[1]) : 0;
    }

    return account;
  };

  return (
    <>
      <Helmet>
        <title>
          {id == "new" ? "Create New" : "Update "} Account · CMS Electricals
        </title>
      </Helmet>
      <Col md={12} data-aos={"fade-up"} data-aos-delay={200}>
        <CardComponent
          showCardHeader={true}
          showBackButton={true}
          className={type === "details" && "after-bg-light"}
          title={`${
            type === "details"
              ? t("View")
              : (edit?.account_id !== undefined && edit?.account_id !== null) ||
                (edit?.id !== undefined && edit?.id !== null)
              ? t("Update")
              : t("Create ")
          } ${t("Bank to Bank Transfer")}`}
        >
          {type == "details" ? (
            <ViewTransaction edit={edit} />
          ) : (
            <Formik
              enableReinitialize={true}
              initialValues={{
                transaction_type: edit?.txn_category || "",

                from_account:
                  edit?.txn_category === "BB" ||
                  edit?.txn_category === "BC" ||
                  edit?.txn_category === "BU"
                    ? firmBankAccount.find(
                        (opt) => opt.value === edit?.account_id
                      )?.value || ""
                    : edit?.txn_category === "UU"
                    ? userAccount.find(
                        (opt) => opt.value === edit?.from_user_id
                      )?.value || ""
                    : edit?.txn_category === "UB"
                    ? userAccount.find(
                        (opt) => opt.value === edit?.from_user_id
                      )?.value || ""
                    : edit?.txn_category === "CB"
                    ? creditorsdata.find(
                        (opt) =>
                          opt.value === (edit?.from_user_id || edit?.user_id)
                      )?.value || ""
                    : "",

                to_account:
                  edit?.txn_category === "BB"
                    ? firmBankAccount?.find(
                        (opt) =>
                          Number(opt.value) === Number(edit?.to_account_id)
                      )?.value || ""
                    : edit?.txn_category === "UU" || edit?.txn_category === "BU"
                    ? userAccount?.find(
                        (opt) =>
                          Number(opt.value) ===
                          Number(edit?.to_user_id || edit?.user_id)
                      )?.value || ""
                    : edit?.txn_category === "BC"
                    ? creditorsdata?.find(
                        (opt) => Number(opt.value) === Number(edit?.user_id)
                      )?.value || ""
                    : edit?.txn_category === "UB" || edit?.txn_category === "CB"
                    ? firmBankAccount?.find(
                        (opt) => Number(opt.value) === Number(edit?.account_id)
                      )?.value || ""
                    : "",

                date:
                  edit?.bank_txn_date || new Date().toISOString().slice(0, 10),
                amount: edit?.bank_amount || edit?.user_amount || "",
                remark: edit?.remark || edit?.user_remark || "",
                transaction_id: edit?.bank_txn_id || edit?.transaction_id || "",
                payment_mode:
                  edit?.to_bank_payment_mode_id ||
                  Number(edit?.payment_mode_id) ||
                  "",
                transaction_for:
                  edit?.transaction_category === "Fund"
                    ? "F"
                    : edit?.transaction_category === "Stock"
                    ? "S"
                    : "",
              }}
              validationSchema={addBanktobanktransferSchema}
              onSubmit={handleSubmit}
            >
              {(props) => (
                <Form onSubmit={props.handleSubmit}>
                  <Row className="g-3">
                    {/* Transaction Type */}
                    <Form.Group as={Col} md={4}>
                      <Form.Label>
                        Transaction Type <span className="text-danger">*</span>
                      </Form.Label>
                      <MyInput
                        name="transaction_type"
                        formikProps={props}
                        customType="select"
                        className="cursor-pointer"
                        selectProps={{ data: transactionTypes }}
                        isDisabled={edit?.id}
                        onChange={(option) => {
                          const value = option?.value || "";
                          props.setFieldValue("transaction_type", value);
                          fetchPaymentModes(value);

                          // Always reset form fields and state
                          props.setFieldValue("from_account", "");
                          props.setFieldValue("to_account", "");
                          setFromHolderName("");
                          setToHolderName("");
                          setAmountError("");
                          setFilteredFirmBankAccount([]);
                          setFilteredUserAccount([]);

                          if (!value) {
                            setUserAccount([]);
                            setFirmBankAccount([]);
                            setCreditorData([]);
                          } else {
                            if (
                              value === "BB" ||
                              value === "BU" ||
                              value === "BC"
                            ) {
                              fetchAllBankData();
                              fetchAllHrEmployeesData();
                              fetchAllHrCrediotrsData();
                            }

                            if (value === "UU") {
                              fetchAllHrEmployeesData();
                            }

                            if (value === "UB") {
                              fetchAllHrEmployeesData();
                              fetchAllBankData();
                            }

                            if (value === "CB") {
                              fetchAllHrCrediotrsData();
                              fetchAllBankData();
                            }
                          } //else
                        }}
                      />
                    </Form.Group>

                    {/* From Account */}
                    <Form.Group as={Col} md={4}>
                      <Form.Label>
                        {t(
                          `From ${
                            props.values.transaction_type == "UB" ||
                            props.values.transaction_type == "UU"
                              ? "User Bank"
                              : props.values.transaction_type == "CB"
                              ? "Creditors"
                              : "Company Bank"
                          } `
                        )}
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <MyInput
                        name="from_account"
                        formikProps={props}
                        customType="select"
                        isDisabled={edit?.id}
                        selectProps={{
                          data:
                            props?.values?.transaction_type === "UU" ||
                            props?.values?.transaction_type === "UB"
                              ? userAccount.filter(
                                  (item) => item.closing_balance > 0
                                )
                              : props?.values?.transaction_type === "CB"
                              ? creditorsdata
                              : firmBankAccount.filter(
                                  (item) => item.closing_balance > 0
                                ),
                        }}
                        onChange={(option) => {
                          props?.setFieldValue(
                            "from_account",
                            option?.value || ""
                          );
                          setFromHolderName(option?.account_number || "");

                          if (props?.values?.transaction_type == "BB") {
                            const filteredData = firmBankAccount?.filter(
                              (item) => item?.value !== option?.value
                            );
                            setFilteredFirmBankAccount(filteredData);
                          }
                          if (props?.values?.transaction_type == "UU") {
                            const filteredData = userAccount?.filter(
                              (item) => item?.value !== option?.value
                            );
                            setFilteredUserAccount(filteredData);
                          }

                          if (props?.values?.transaction_type == "BU") {
                            fetchAllHrEmployeesData();
                          }

                          if (props?.values?.transaction_type == "UB") {
                            fetchAllBankData();
                          }

                          if (props?.values?.transaction_type == "CB") {
                            fetchAllHrCrediotrsData();
                            fetchAllBankData();
                          }
                        }}
                      />
                    </Form.Group>
                    <Form.Group as={Col} md={4}>
                      <Form.Label>
                        {" "}
                        {t(
                          `To ${
                            props.values.transaction_type == "UU" ||
                            props.values.transaction_type == "BU"
                              ? "User Bank"
                              : props.values.transaction_type == "BC"
                              ? "Crediors Bank"
                              : "Company Bank"
                          } `
                        )}
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <MyInput
                        name="to_account"
                        formikProps={props}
                        customType="select"
                        isDisabled={edit?.id}
                        selectProps={{
                          data:
                            props.values.transaction_type === "BB" && !edit?.id
                              ? filteredFirmBankAccount
                              : props.values.transaction_type === "UB" ||
                                props.values.transaction_type === "CB"
                              ? firmBankAccount
                              : props.values.transaction_type === "BB" &&
                                edit?.id
                              ? firmBankAccount
                              : props.values.transaction_type === "UU" &&
                                edit?.id
                              ? userAccount // <--- yaha aa gaya tera new condition
                              : props.values.transaction_type === "BU"
                              ? userAccount
                              : props.values.transaction_type === "UU"
                              ? filteredUserAccount
                              : props.values.transaction_type === "BC"
                              ? creditorsdata
                              : filteredUserAccount,
                        }}
                        onChange={(option) => {
                          props.setFieldValue(
                            "to_account",
                            option?.value || ""
                          );
                          setToHolderName(option?.account_number || "");
                        }}
                      />
                    </Form.Group>

                    {/* Transaction for */}
                    {["BU", "UU"].includes(props.values.transaction_type) && (
                      <Form.Group as={Col} md={4}>
                        <Form.Label>
                          Transaction for <span>*</span>{" "}
                        </Form.Label>
                        <MyInput
                          name="transaction_for"
                          formikProps={props}
                          isDisabled={edit?.id}
                          customType="select"
                          selectProps={{ data: transactionFor }}
                          onChange={(option) => {
                            props.setFieldValue(
                              "transaction_for",
                              option?.value || ""
                            );
                            console.log(
                              "Transaction for changed to",
                              option?.value
                            );
                          }}
                        />
                      </Form.Group>
                    )}

                    {/* Auto Filled From Holder */}
                    <Form.Group as={Col} md={4}>
                      <Form.Label>From Account Holder Number</Form.Label>
                      <Form.Control
                        name="from_account_holder_number"
                        isDisabled={edit?.id}
                        type="text"
                        value={fromHolderName}
                        readOnly
                        placeholder="Account Number"
                      />
                    </Form.Group>

                    {/* Auto Filled To Holder */}
                    <Form.Group as={Col} md={4}>
                      <Form.Label>To Account Holder Number</Form.Label>
                      <Form.Control
                        name="to_account_holder_number"
                        type="text"
                        value={toHolderName}
                        isDisabled={edit?.id}
                        readOnly
                        placeholder=" Account Number"
                        onChange={(e) => setToHolderName(e.target.value)}
                      />
                    </Form.Group>

                    {/* Date */}
                    <Form.Group as={Col} md={4}>
                      <Form.Label>
                        {" "}
                        Transaction Date <span className="text-danger">*</span>
                      </Form.Label>
                      <DatePickercomp
                        name="date"
                        value={props.values.date}
                        sendDate={(date) => props.setFieldValue("date", date)}
                        isDisabled={edit?.id ? true : false}
                        onChange={(date) => {
                          const formattedDate = date
                            ?.toISOString()
                            .slice(0, 10);
                          props.setFieldValue("date", formattedDate);
                        }}
                      />
                    </Form.Group>

                    {/* Amount */}
                    <Form.Group as={Col} md={4}>
                      <Form.Label>
                        Transfer Amount <span className="text-danger">*</span>
                      </Form.Label>
                      <input
                        type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                        name="amount"
                        placeholder="Enter Amount"
                        className="form-control"
                        value={props.values.amount}
                        formikProps={props}
                        onChange={(e) => {
                          const value = e.target.value;

                          const amount = Number(value);
                          // Keep raw string in the field so an in-progress decimal
                          // like "1." survives re-render — `Number("1.")` is 1 which
                          // would strip the trailing dot and block "1.5" entry.
                          props.setFieldValue("amount", value);

                          let balance = 0;
                          let user_balance = 0;
                          if (
                            ["BB", "BC", "BU"].includes(
                              props.values.transaction_type
                            )
                          ) {
                            balance = firmBankAccount.find(
                              (acc) => acc.value === props.values.from_account
                            )?.closing_balance;

                            user_balance = userAccount.find(
                              (acc) => acc.value === props.values.to_account
                            )?.closing_balance;
                          } else if (
                            ["UB", "UU"].includes(props.values.transaction_type)
                          ) {
                            balance = userAccount.find(
                              (acc) => acc.value === props.values.from_account
                            )?.closing_balance;
                          }
                          if (["CB"].includes(props.values.transaction_type)) {
                            balance = creditorsdata.find(
                              (acc) => acc.value === props.values.from_account
                            )?.closing_balance;
                          }
                          if (
                            ["UU ", "BU"].includes(
                              props.values.transaction_type
                            ) &&
                            props.values.transaction_for === "F"
                          ) {
                            const fund_limit =
                              userAccount.find(
                                (acc) => acc.value === props.values.to_account
                              )?.fund_limit || 0;

                            let remaining_limit = fund_limit - user_balance;
                            if (amount > remaining_limit) {
                              setAmountError(
                                `Amount exceeds fund limit. Available fund limit is ₹${fund_limit}
                                and remaining limit is ₹${remaining_limit}`
                              );
                              return;
                            }

                            if (amount > balance) {
                              setAmountError(
                                `Insufficient balance. Available balance is ₹${balance}`
                              );
                            } else {
                              setAmountError("");
                            }
                          } else {
                            if (amount > balance) {
                              setAmountError(
                                `Insufficient balance. Available balance is ₹${balance}`
                              );
                            } else {
                              setAmountError("");
                            }
                          }
                        }}
                      />

                      {/* ✅ Show message only once */}
                      {amountError && (
                       <Form.Text className="text-danger">{amountError}</Form.Text>
                      )}
                    </Form.Group>

                    <Form.Group as={Col} md={4}>
                      <Form.Label>
                        Transaction Id <span className="text-danger">*</span>
                      </Form.Label>
                      <MyInput
                        name="transaction_id"
                        type="text"
                        placeholder="Enter Transaction Id"
                        formikProps={props}
                        onChange={(e) =>
                          props.setFieldValue("transaction_id", e.target.value)
                        }
                      />
                    </Form.Group>
                    <Form.Group as={Col} md={4}>
                      <Form.Label>Payment Mode </Form.Label>
                      <MyInput
                        name="payment_mode"
                        formikProps={props}
                        customType="select"
                        selectProps={{
                          data: paymentMode,
                        }}
                        onChange={(option) => {
                          props.setFieldValue(
                            "payment_mode",
                            option?.value || ""
                          );
                        }}
                      />
                    </Form.Group>

                    {/* Remark */}
                    <Form.Group as={Col} md={14}>
                      <Form.Label>Remark / Narration</Form.Label>
                      <MyInput
                        name="remark"
                        customType="multiline"
                        placeholder="Enter Remark"
                        formikProps={props}
                        onChange={(e) =>
                          props.setFieldValue("remark", e.target.value)
                        }
                      />
                    </Form.Group>

                    {/* Attachment */}

                    {/* Submit */}
                    <Form.Group as={Col} md={12}>
                      <div className="mt-4 text-center">
                        <button
                          type={`${edit?.id ? "button" : "submit"}`}
                          onClick={() => setShowAlert(edit?.id && true)}
                          disabled={props?.isSubmitting || !!amountError}
                          className="shadow border-0 purple-combo cursor-pointer px-4 py-1"
                        >
                          {props?.isSubmitting ? (
                            <>
                              <Spinner
                                animation="border"
                                variant="primary"
                                size="sm"
                              />{" "}
                              {t("PLEASE WAIT")}...
                            </>
                          ) : edit?.id ? (
                            t("UPDATE")
                          ) : (
                            t("CREATE")
                          )}
                        </button>
                        <ConfirmAlert
                          size={"sm"}
                          deleteFunction={props.handleSubmit}
                          hide={setShowAlert}
                          show={showAlert}
                          title={"Confirm UPDATE"}
                          description={"Are you sure you want to update this!!"}
                        />
                      </div>
                    </Form.Group>
                  </Row>
                </Form>
              )}
            </Formik>
          )}
        </CardComponent>
      </Col>
    </>
  );
};

export default BankTransaction;
